import React from 'react';
import PropTypes from 'prop-types';
import './AccountItem.css';
import PercentageChange from '../PercentageChange/PercentageChange'
import { penceToPounds } from '../../utils/currency';
import NumberFormat from 'react-number-format';
import * as FontAwesome from 'react-icons/lib/fa'

const defaultProps = {
  balanceValue: 0
}

class AccountItem extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      titleValue: '',
      balanceValue: 0,
      disabledSave: true,
      isSavingBalance: false,
      isSavingTitle: false
    }

    this.handleOnSave = this.handleOnSave.bind(this)
    this.handleOnDelete = this.handleOnDelete.bind(this)
    this.handleTitleChange = this.handleTitleChange.bind(this)
    this.handleBalanceChange = this.handleBalanceChange.bind(this)
  }

  componentWillMount() {
    this.setState({
      titleValue: this.props.account.accountName,
      balanceValue: (this.props.account.balance / 100),
    });
  }

  componentWillReceiveProps(nextProps) {
    const hasUpdated = nextProps.account.accountName !== this.props.account.accountName ||
    nextProps.account.balance !== this.props.account.balance;
    if (hasUpdated) {
      setTimeout(() => {
        this.setState({
          isSaving: false,
          disabledSave: true,
          isSavingBalance: false,
          isSavingTitle: false,
          balanceValue: nextProps.account.balance / 100
        });
      }, 500)
    }
  }

  handleOnSave() {
    const { groupId, account } = this.props

    const hasEdited = this.state.titleValue !== this.props.account.accountName ||
      this.state.balanceValue !== this.props.account.balance

    if (!hasEdited) {
      // alert('Please make a change')
      return
    }

    this.setState({ isSaving: true });

    this.props.handleUpdateAccount(groupId, {
      ...this.props.account,
      accountName: this.state.titleValue,
      currency: this.state.currencyValue,
      balance: parseFloat(this.state.balanceValue) * 100, // upload as pence
    })

  }

  handleOnDelete() {
    const { groupId, account } = this.props
    this.props.handleDeleteAccount(groupId, account._id)
  }

  handleTitleChange(event) {
    this.setState({ titleValue: event.target.value })
  }

  handleBalanceChange(value) {
    this.setState({ balanceValue: parseFloat(value) * 100 })
  }

  render() {
    return (
      <li className="assets-item">
        <div className="assets-item__inner">
          <div className="account-name">
          <div className="input-wrapper">
            <input
              type="text"
              className="form-control"
              onChange={this.handleTitleChange}
              value={this.state.titleValue}
              placeholder='e.g. Savings Account'
              onBlur={() => {
                this.setState({ isSavingTitle: true })
                this.handleOnSave()
              }}
              onFocus={() => this.setState({ disabledSave: false })}
            />
            {this.state.isSavingTitle && <FontAwesome.FaCheck />}
            </div>
          </div>

          <div className="account-balance">

            <div className="input-wrapper">
              <NumberFormat
                className="form-control"
                value={this.state.balanceValue}
                thousandSeparator={true}
                prefix={'£'}
                onBlur={() => {
                  this.setState({ isSavingBalance: true })
                  this.handleOnSave()
                }}
                onValueChange={(values) => {
                  const {formattedValue, value} = values;
                  console.log('VALUE', parseFloat(value) * 100)
                  this.setState({ balanceValue: value })
                }}
                onFocus={() => this.setState({ disabledSave: false })}
              />
              {this.state.isSavingBalance && <FontAwesome.FaCheck />}
            </div>

          </div>
          <div className="account-actions">
            <button className="btn btn-danger" onClick={this.handleOnDelete}>
              X
          </button>
          </div>
        </div>
      </li>
    )
  }
}

AccountItem.defaultProps = defaultProps;

export default AccountItem



// WEBPACK FOOTER //
// ./src/components/AccountItem/AccountItem.js